module.exports = "https://coursera_assets.s3.amazonaws.com/images/28e378069e06f0e87ccadae1dd34b1e3.jpg";